import MDRVaultItemizedForm from "components/features/request-module/media-destruction-request-vault-itemized/MDRVaultItemizedForm";

const MediaDestructionRequestDetailVaultItemized = () => {
  return <MDRVaultItemizedForm />;
};

export default MediaDestructionRequestDetailVaultItemized;
